import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/enable/layer.enable.mutation.gql"
import type {
  LayerEnableMutation,
  LayerEnableMutationVariables,
} from "@/v2-backoffice-client/layer/enable/__types__/layer.enable.mutation"

type Options = MutationHookOptions<
  LayerEnableMutation,
  LayerEnableMutationVariables
>

export function useLayerEnableMutation(options?: Options) {
  return useMutation<LayerEnableMutation, LayerEnableMutationVariables>(
    mutation,
    options,
  )
}
